<template>
    <div class="px-3 sm:px-28">
        <p class="text-center text-xl font-semibold text-neutral-200 mb-6 max-w-screen-sm mx-auto">
            {{ title || 'Trusted by developers and product teams worldwide' }}
        </p>
        <div class="text-center overflow-hidden py-4 sm:py-2">
            <div class="relative w-full overflow-hidden py-8">
                <!-- Gradient overlays -->
                <div
                    class="absolute top-0 bottom-0 left-0 w-[25%] z-10 pointer-events-none bg-gradient-to-r from-[rgba(18,18,20,1)] to-transparent">
                </div>
                <div
                    class="absolute top-0 bottom-0 right-0 w-[25%] z-10 pointer-events-none bg-gradient-to-l from-[rgba(18,18,20,1)] to-transparent">
                </div>

                <!-- Logo track -->
                <div class="flex gap-4 w-fit animate-scroll">
                    <!-- First set of logos -->
                    <div class="flex gap-4">
                        <div v-for="customer in CUSTOMERS" :key="customer.title + '-1'"
                            class="flex-none w-[200px] h-[100px] flex items-center justify-center px-4">
                            <img :src="`/images/customers/dark/${customer.img_url}`" :alt="customer.title"
                                :title="customer.title" :loading="lazy ? 'lazy' : undefined"
                                :decoding="lazy ? 'async' : undefined" class="max-w-full max-h-full object-contain" />
                        </div>
                    </div>
                    <!-- Duplicate set for seamless loop -->
                    <div class="flex gap-4">
                        <div v-for="customer in CUSTOMERS" :key="customer.title + '-2'"
                            class="flex-none w-[200px] h-[100px] flex items-center justify-center px-4">
                            <img :src="`/images/customers/dark/${customer.img_url}`" :alt="customer.title"
                                :title="customer.title" :loading="lazy ? 'lazy' : undefined"
                                :decoding="lazy ? 'async' : undefined" class="max-w-full max-h-full object-contain" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
const CUSTOMERS = [
    { title: 'ThriveLearning.com', img_url: 'thrive.png' },
    { title: 'Humi.ca', img_url: 'humi.webp' },
    { title: 'Paidiem.com', img_url: 'paidiem.png' },
    { title: 'HeroHunt.ai', img_url: 'herohunt.png' },
    { title: 'HireTechLadies.com', img_url: 'techladies.webp' },
    { title: 'Sailes.ai', img_url: 'sailes.png' },
    { title: 'Foresight', img_url: 'foresight.png' },
    { title: 'Recital', img_url: 'recital.png' },
    { title: 'Talin', img_url: 'talin.png' },
    { title: 'Sync2Hire', img_url: 'sync2hire.png' },
    { title: 'HoneyBook', img_url: 'honeybook.svg' },
];

export default {
    props: {
        title: {
            type: String,
            required: false,
        },
        // Opt-in loading="lazy"/decoding="async" for placements confirmed to be
        // below the fold (see TICKET-10191). Defaults to eager to avoid changing
        // behavior on other pages without measuring their layout.
        lazy: Boolean,
    },
    data() {
        return {
            CUSTOMERS
        };
    }
};
</script>

<style scoped>
/* Only keep the animation keyframe and hover state */
@keyframes scroll {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-50%);
    }
}

.animate-scroll {
    animation: scroll 30s linear infinite;
}

.animate-scroll:hover {
    animation-play-state: paused;
}
</style>